import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { IAssetWithSignedUrls } from "../../types";
import { api } from "../../utils";
import { useAuth } from "../useAuth";

export interface ICreateAssetsParameters {
    files: File[];
    productId: string;
    variantId: string;
    tags?: string;
    position: number;
    header?: string;
    description?: string;
    altText?: string;
}

export const useCreateAssets = (
    invalidQueryKeys: string | string[],
): UseMutationResult<
    IAssetWithSignedUrls[],
    unknown,
    ICreateAssetsParameters
> => {
    const auth = useAuth();
    const queryClient = useQueryClient();
    return useMutation<
        IAssetWithSignedUrls[],
        unknown,
        ICreateAssetsParameters
    >({
        mutationFn: async (
            parameters: ICreateAssetsParameters,
        ): Promise<IAssetWithSignedUrls[]> => {
            const { files } = parameters;

            const token = auth.token;

            if (!token) {
                throw new Error(
                    "Cannot create assets without authorization token.",
                );
            }

            const assetsResponse = await api.Asset.create({
                ...parameters,

                token,
            });

            await api.Asset.createS3Assets(assetsResponse, files);

            return assetsResponse;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
